import React, { useRef } from "react";
import { CustomTextField } from "../Utility/utility";
import SearchIcon from "@material-ui/icons/Search";
import { InputAdornment } from "@material-ui/core";
import { Button } from "@material-ui/core";
import filterNew from "images/filterNew.svg";
import "../style.css";
import "./style.css";
import HistoryTable from "./HistoryTable";
import downloadWhite from "images/downloadWhite.svg";
import { useSelector } from "react-redux";

const History = ({
  handlePageClickHistory,
  handleOpen,
  setSearchHistory,
  handleSubmitHistory,
  handleHistoryDownload,
  
}) => {
  const debounceTimeout = useRef(null);
 const { loaderStatus} =
    useSelector((store) => store.gstr2a2bNewFetchReducer);
  const handleInputChange = (event) => {
    const search = event.target.value;
    if (search?.length > 50) {
      return;
    }
    setSearchHistory(search);
    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }
    debounceTimeout.current = setTimeout(() => {
      handleSubmitHistory(false, search,1,false);
    }, 500);
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "center",
        }}
      >
        <div style={{ width: "35%" }}>
          <CustomTextField
            style={{ backgroundColor: "white" }}
            placeholder="Search"
            variant="outlined"
            size="small"
            onChange={(e) => handleInputChange(e)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
          />
        </div>
        <Button
          onClick={handleOpen}
          disabled={loaderStatus}
          type="submit"
          variant="contained"
          color="primary"
          style={{
            backgroundColor: "#4f2d7f",
            color: "white",
            textTransform: "capitalize",
            height: "32px",
            marginTop: "0.4em",
            marginLeft: "1.5em",
            fontSize: "12px",
          }}
        >
          <img
            src={filterNew}
            alt="filter"
            style={{ width: "30px", height: "18px" }}
          />
          Filter
        </Button>
        <Button
          onClick={handleHistoryDownload}
          disabled={loaderStatus}
          type="submit"
          variant="contained"
          color="primary"
          style={{
            backgroundColor: "#4f2d7f",
            color: "white",
            textTransform: "capitalize",
            height: "32px",
            marginTop: "5px",
            marginLeft: "1.5em",
            fontSize: "12px",
          }}
        >
          <img
            src={downloadWhite}
            alt="Download"
            style={{
              width: "30px",
              height: "20px",
              paddingBottom: "3px",
            }}
          />
          Download
        </Button>
      </div>
      <HistoryTable handlePageClickHistory={handlePageClickHistory} />
    </>
  );
};

export default History;
